module.exports = __webpack_public_path__ + "static/img/product_live.0171e6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/product_live.jpg
// module id = WFH8
// module chunks = 0